document.addEventListener('DOMContentLoaded', () => {
  function calculateDeliveryDate() {
    const now = new Date();
    const utcTime = now.getTime() + (now.getTimezoneOffset() * 60 * 1000);
    const istOffset = 5.5 * 60 * 60 * 1000;
    const istNow = new Date(utcTime + istOffset);

    const minDays = 3;
    const maxDays = 5;

    const minDate = new Date(istNow);
    minDate.setDate(minDate.getDate() + minDays);

    const maxDate = new Date(istNow);
    maxDate.setDate(maxDate.getDate() + maxDays);

    function formatDate(date) {
      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      const day = date.getDate();
      const month = months[date.getMonth()];
      return `${day} ${month}`;
    }

    const minDateFormatted = formatDate(minDate);
    const maxDateFormatted = formatDate(maxDate);

    return `${minDateFormatted} - ${maxDateFormatted}`;
  }

  const baseText = 'Expected Delivery in ';
  const deliveryDateRange = calculateDeliveryDate();

  const deliveryDateClaims = document.querySelectorAll('[data-expected-delivery-date="true"]');
  deliveryDateClaims.forEach((claim) => {
    claim.textContent = baseText + deliveryDateRange;
  });

  const purchaseBenefitsDelivery = document.querySelector('[data-purchase-benefits-delivery]');
  const purchaseBenefitsDeliveryRow = document.querySelector('[data-purchase-benefits-delivery-row]');
  if (purchaseBenefitsDelivery) {
    document.addEventListener('variant:changed', (event) => {
      const variant = event.detail?.variant;
      if (!variant) return;

      const isOutOfStock = (variant.inventory_quantity || 0) <= 0;
      const continueSellingOff = variant.inventory_policy === 'deny';
      const continueSellingOn = variant.inventory_policy === 'continue';

      if (isOutOfStock && continueSellingOff) {
        if (purchaseBenefitsDeliveryRow) {
          purchaseBenefitsDeliveryRow.classList.add('hidden');
        }
        purchaseBenefitsDelivery.removeAttribute('data-expected-delivery-date');
        purchaseBenefitsDelivery.setAttribute('data-display-mode', 'hidden');
        purchaseBenefitsDelivery.textContent = '';
        return;
      }

      if (purchaseBenefitsDeliveryRow) {
        purchaseBenefitsDeliveryRow.classList.remove('hidden');
      }

      if (isOutOfStock && continueSellingOn) {
        purchaseBenefitsDelivery.removeAttribute('data-expected-delivery-date');
        purchaseBenefitsDelivery.setAttribute('data-display-mode', 'variant-offer');
        purchaseBenefitsDelivery.textContent = variant.variant_offer || '';
        return;
      }
      purchaseBenefitsDelivery.setAttribute('data-expected-delivery-date', 'true');
      purchaseBenefitsDelivery.setAttribute('data-display-mode', 'delivery-date');
      purchaseBenefitsDelivery.textContent = baseText + deliveryDateRange;
    });
  }
});
